import React, { useState, useEffect } from 'react';
import LogCard from './../components/LogCard';
import { useNavigate } from 'react-router-dom';
import { Refresh } from '@mui/icons-material';
import { apiAppFetch } from '../utils/apiFetch';
import './../Trades.css';

const RejectionLogs = () => {
  const navigate = useNavigate();
  const [rejectionLogs, setRejectionLogs] = useState([]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const getRejectionLogs = async () => {
    try {
      const response = await apiAppFetch('getTodayRejectionLog', {
        method: 'POST',
        body: JSON.stringify({}),
      });

      if (response.status === 401) {
        navigate('/login', { replace: true });
        return;
      }

      if (!response.ok) {
        return;
      }

      const data = await response.json();
      setRejectionLogs(Array.isArray(data) ? data : []);
    } catch (error) {
      // fetch failed silently
    }
  };

  useEffect(() => {
    getRejectionLogs();
  }, []);

  const handleRefresh = () => {
    getRejectionLogs();
  };

  return (
    <div className="trades-page">
      <button className="refresh-button" onClick={handleRefresh}><Refresh /></button>

      {rejectionLogs.map((log) => (
        <LogCard
          key={log.id}
          log={log}
        />
      ))}
    </div>
  );
};

export default RejectionLogs;
